// Desktop-only collapse/expand for the always-visible vertical filter
// sidebar (blocks/filters.liquid). Reuses the theme's own .hidden utility
// (display:none) so the stock CSS Grid rule that reclaims the product
// grid's column when the sidebar is hidden keeps working untouched — this
// only adds a button, a smooth enter/exit fade for the sidebar card, and
// localStorage persistence on top of what the theme already does.
const STORAGE_KEY = 'ar-vertical-facets-collapsed';
const TRANSITION_FALLBACK_MS = 260;

function collapse(toggle, panel) {
  toggle.setAttribute('aria-expanded', 'false');
  panel.classList.add('is-closed-visual');

  let done = false;
  function finish() {
    if (done) return;
    done = true;
    panel.classList.add('hidden');
    panel.removeEventListener('transitionend', finish);
  }
  panel.addEventListener('transitionend', finish);
  // transitionend can fail to fire (reduced-motion 0ms transitions,
  // interrupted animations) — the fallback guarantees .hidden still gets
  // applied so the grid reflow isn't left stuck in a half-open state.
  setTimeout(finish, TRANSITION_FALLBACK_MS);
}

function expand(toggle, panel) {
  toggle.setAttribute('aria-expanded', 'true');
  panel.classList.remove('hidden');
  // Force a layout read so the browser commits the "still visually
  // closed" state before is-closed-visual is removed below — without
  // this the class removal and the hidden removal would be batched into
  // the same style recalculation and the fade-in wouldn't play.
  void panel.offsetWidth;
  panel.classList.remove('is-closed-visual');
}

function initToggle(toggle) {
  if (toggle.dataset.verticalFacetsInit) return;
  toggle.dataset.verticalFacetsInit = 'true';

  const panelId = toggle.getAttribute('data-panel-id');
  const panel = panelId ? document.getElementById(panelId) : null;
  if (!panel) return;

  toggle.addEventListener('click', function () {
    const isCurrentlyCollapsed = panel.classList.contains('hidden');
    if (isCurrentlyCollapsed) {
      expand(toggle, panel);
    } else {
      collapse(toggle, panel);
    }
    try {
      localStorage.setItem(STORAGE_KEY, isCurrentlyCollapsed ? '0' : '1');
    } catch (e) {}
  });
}

function initAll() {
  document.querySelectorAll('[data-vertical-facets-toggle]').forEach(initToggle);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

// Collection/search results re-render via section morphing on filter
// changes — catch any toggle instance that morphing brings in fresh.
const verticalFacetsObserver = new MutationObserver(function () {
  document.querySelectorAll('[data-vertical-facets-toggle]:not([data-vertical-facets-init])').forEach(initToggle);
});
verticalFacetsObserver.observe(document.body, { childList: true, subtree: true });
